import React from "react";
import ErrorLabel from "../ErrorLabel/ErrorLabel";

const ErrorLabelWithValue = ({ isRequired, error, validations }) => {
  if (isRequired) {
    return (
      <ErrorLabel>
        {validations.find(({ type }) => type === "required").params[0]}
      </ErrorLabel>
    );
  }

  if (!isRequired && error) {
    return <ErrorLabel>{error}</ErrorLabel>;
  }
  return null;
};

export default ErrorLabelWithValue;
